const elGR= {
    login: {
      title: 'Είσοδος',
      sign_in_btn: 'Είσοδος'
    },
    bar: {
        logout: 'Αποσύνδεση',
        languages: 'Γλώσσες',
        settings: 'Άνοιγμα ρυθμίσεων'
    },
    language: {
      name: 'Ελληνικά (EL)',
    },
    attributePage: {
        title: 'Αλλαγές σε χαρακτηριστικά',
        viewChanges: 'Εμφάνιση αλλαγών',
        dateTime: 'Ημερομηνία',
        notificationType: 'Τύπος ειδοποίησης',
        notificationValue: 'Τιμή ειδοποίησης',
        oldValue: 'Προηγούμενη τιμή',
        newValue: 'Νέα τιμή',
        accept: 'Αποδοχή',
        reject: 'Απόρριψη',
    },
    Home: 'Αρχική',
    load: 'Εκτέλεση αρχικής φόρτωσης...',
    Requested: "Ζητήθηκε",
    Viewed: "Προβλήθηκε",
    Executing: "Εκτελείται",
    Completed: "Ολοκληρώθηκε",
    Expired: "Έληξε",
    Cancelled: "Ακυρώθηκε",
    Error: "Σφάλμα",
    Rejected: "Απορρίφθηκε",
    error: 'Κάτι πήγε λάθος, δοκιμάστε ξανά αργότερα.',
    displayname: 'Εμφανιζόμενο όνομα',
    givenname: 'Όνομα',
    surname: 'Επώνυμο',
    email: 'Email',
    mail: 'Email',
    name: 'Όνομα',
    firstname: 'Όνομα',
    lastname: 'Επώνυμο',
    footer_copyright: 'Με την επιφύλαξη παντός δικαιώματος.'
  };
  
  export default elGR;
  